import { atom } from "jotai";
import { Message, Thread } from "./types";

export const currentThreadAtom = atom<Thread | null>(null);
export const currentMessagesAtom = atom<Message[]>([]);
export const isOutercomHiddenAtom = atom(true);
